import { render, staticRenderFns } from "./OrderMallDetail.vue?vue&type=template&id=61cedbdc&scoped=true"
import script from "./OrderMallDetail.vue?vue&type=script&lang=ts"
export * from "./OrderMallDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderMallDetail.vue?vue&type=style&index=0&id=61cedbdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cedbdc",
  null
  
)

export default component.exports